import React from "react";
import {DatePickerViewer, DialogViewer, NotificationViewer, SpinnerViewer} from '@posco/posco-ui-react';

const Viewers = (props) => {
  return (
    <div>
      <DatePickerViewer />
      <NotificationViewer />
      <SpinnerViewer />
      <DialogViewer />
      {props.children}
    </div>
  );
}
export default Viewers;
